import { precision } from './precision';

export function money(value: string | number) {
  const innerValue = typeof value === 'string' ? parseFloat(value) : value;
  return `$${precision(value, 2)}`;
}